import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'TextInput' })({
    field: {
        flex: 1
    },
    notchedOutline: {
        background: '#F8F8F8',
        border: 0,
        zIndex: -1
    },
    input: {
        padding: '26.5px 24px 10.5px 20px',
        fontSize: 14,
        fontWeight: 500,
        height: 21,
        lineHeight: '21px',
        '&:not(:disabled)': {
            color: '#4D4D4D'
        },
        '&::placeholder': {
            color: '#8E8E8E'
        },
        '&:focus': {
            borderRadius: 16
        },
        '&::-webkit-outer-spin-button': {
            appearance: 'none',
            margin: 0
        },
        '&::-webkit-inner-spin-button': {
            appearance: 'none',
            margin: 0
        },
        '&[type=number]': {
            MozAppearance: 'textfield'
        }
    },
    inputRoot: {
        background: '#F8F8F8',
        borderRadius: 16
    },
    label: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '21px',
        transform: 'translate(20px, 18px) scale(1)',
        color: '#8E8E8E'
    },
    labelFocused: {
        color: '#8E8E8E !important'
    },
    labelShrink: {
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '16px',
        transform: 'translate(20px, 12px) !important'
    },
    error: {
        whiteSpace: 'pre-wrap'
    }
});
